// import { Injectable } from '@angular/core';
// import { Observable, Subject } from 'rxjs';
// import { MessageHandlerService } from './message-handler.service';
// import { NzNotificationService } from 'ng-zorro-antd/notification';
//
// @Injectable({
//   providedIn: 'root'
// })
// export class WebSocketService {
//   private socket!: WebSocket;
//   public messageSubject = new Subject<any>();
//
//   constructor(
//     private messageHandlerService: MessageHandlerService,
//     private notification: NzNotificationService,
//   ) { }
//
//   public start(url: string, token: any): void {
//     if (this.socket) return;  // Ensure connection is established only once
//     this.socket = new WebSocket(url);
//     this.socket.onopen = (e: any) => {
//       let authData = token
//       this.socket.send(JSON.stringify(authData));
//     };
//
//     this.socket.onmessage = (event: MessageEvent) => {
//       const message = JSON.parse(event.data);
//       this.messageSubject.next(message)
//       if (message?.type == 'announcement' && message?.status == "success") {
//         const notification = this.notification.info(
//           'اعلان جدید!',
//           `<div class='info-background-notification'> <strong> ${message?.data?.title} : </strong> ${message?.data?.content}</div>`,
//           {
//             nzPlacement: 'top',
//             nzDuration: 0, // تنظیم مدت زمان به 0 برای باقی ماندن نوتیفیکیشن تا زمان کلیک
//           }
//         );
//       }
//     };
//
//     this.socket.onerror = (error: Event) => {
//       this.messageHandlerService.parseError(error);
//     };
//
//     this.socket.onclose = () => {
//       console.log('WebSocket connection closed.');
//     };
//   }
//
//   public getMessages(): Observable<any> {
//     return this.messageSubject.asObservable();
//   }
// }
//

import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MessageHandlerService } from './message-handler.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket!: WebSocket;
  public messageSubject = new Subject<any>();
  private reconnectInterval: any;
  private reconnectDelay = 30000;

  constructor(
    private messageHandlerService: MessageHandlerService,
    private notification: NzNotificationService,
  ) { }

  public start(url: string, token: any): void {
    this.connect(url, token);

    // تلاش مجدد برای اتصال هر یک دقیقه
    this.reconnectInterval = setInterval(() => {
      if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
        this.connect(url, token);
      }
    }, this.reconnectDelay);
  }

  private connect(url: string, token: any): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) return; // Ensure connection is established only once

    this.socket = new WebSocket(url);

    this.socket.onopen = (e: any) => {
      clearInterval(this.reconnectInterval); // Stop reconnection attempts once connected
      let authData = token;
      this.socket.send(JSON.stringify(authData));
    };

    this.socket.onmessage = (event: MessageEvent) => {
      const message = JSON.parse(event.data);
      console.log(message);
      this.messageSubject.next(message);
      if (message?.type == 'announcement' && message?.status == "success") {
        const notification = this.notification.info(
          'اعلان جدید!',
          `<div class='info-background-notification'> <strong> ${message?.data?.title} : </strong> ${message?.data?.content}</div>`,
          {
            nzPlacement: 'top',
            nzDuration: 0, // تنظیم مدت زمان به 0 برای باقی ماندن نوتیفیکیشن تا زمان کلیک
          }
        );
      }
    };

    this.socket.onerror = (error: Event) => {
      // console.log(`error`, error);
      // this.messageHandlerService.parseError(error);
    };

    this.socket.onclose = () => {
      // console.log('WebSocket connection closed.');
      // تلاش مجدد برای اتصال در صورت بسته شدن سوکت
      if (!this.reconnectInterval) {
        this.reconnectInterval = setInterval(() => {
          if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
            this.connect(url, token);
          }
        }, this.reconnectDelay);
      }
    };
  }

  public getMessages(): Observable<any> {
    return this.messageSubject.asObservable();
  }
}
